import NewsMain from '@/components/News'
const News = () => {
    const element = (<NewsMain />)
    return element
}
export default News